import { AxiosPromise, AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { snakizeObject } from '@cvt/helpers/object';

import { mapMediaUploadCrudData, mapMediaUploadResponse } from './mediaClient.formatter';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const uploadMedia = (payload: Tributes.MediaUploadRequest): AxiosPromise<Tributes.MediaUploadResponse> => {
  return request({
    options: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      url: `${apiBaseUrl}/media/`,
      method: 'POST',
      data: mapMediaUploadCrudData(payload),
    },
  }).then((data: AxiosResponse<Tributes.MediaUploadResponseApi>) => ({
    ...data,
    data: mapMediaUploadResponse(data.data),
  }));
};


const getMedia = (params: { id: number }): AxiosPromise<Tributes.MediaUploadResponse> => {
  return request({
    options: {
      url: `${apiBaseUrl}/media/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Tributes.MediaUploadResponseApi>) => ({
    ...data,
    data: mapMediaUploadResponse(data.data),
  }));
};

const getAllMedia = (params: Tributes.GetListParams): AxiosPromise<CVT.Query.PaginatedResults<Tributes.MediaUploadResponse>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/media/`,
      method: 'GET',
      params: snakizeObject(params),
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<Tributes.MediaUploadResponseApi>>) => ({
    ...data,
    data: {
      ...data.data,
      results: data.data.results.map(mapMediaUploadResponse),
    },
  }));
};

export const mediaClient = {
  getMedia,
  getAllMedia,
  uploadMedia,
};
